<p class="text-sm text-gray-600 p-8">
    {{disclaimer}} 
    <span class="text-yellow-500 underline hover:text-black">
        <a
            [href]="websiteHyperlink">
            {{websiteHyperlink}}
        </a>
    </span>
    .
</p>